import React from 'react';
import ReactDOM from 'react-dom';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Provider } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { App } from './App';
import { store, persistor } from './reducers';
import {PersistGate} from "redux-persist/integration/react";
import ErrorBoundary from './Components/ErrorBoundary';
import { normalizeTrackingParams } from './Utils/normalizeTrackingParams';
import { hashFreeCallbackRedirect } from './Utils/hashFreeCallbackRedirect';

// Dynamically load the Verisoul SDK if configuration variables are set
const loadVerisoulSDK = () => {
  if (document.getElementById('verisoul-sdk-script')) return;

  const projectId = process.env.REACT_APP_VERISOUL_PROJECT_ID;
  const env = process.env.REACT_APP_VERISOUL_ENV;

  if (!projectId || !env) {
    console.error('[Verisoul ERROR] REACT_APP_VERISOUL_PROJECT_ID or REACT_APP_VERISOUL_ENV is missing in .env');
    return;
  }

  const script = document.createElement('script');
  script.id = 'verisoul-sdk-script';
  script.async = true;
  script.src = `https://js.verisoul.ai/${env}/bundle.js`;
  script.setAttribute('verisoul-project-id', projectId);
  script.setAttribute('project_id', projectId);
  document.head.appendChild(script);
  console.log(`[Verisoul] SDK script injected for project ${projectId} in ${env} env.`);
};

// MUST stay the first thing that runs. A survey end link that arrives without
// its "#/" (/completed, /surveys/overquota?..., /%23/terminate) is sent to the
// equivalent hash route before anything reads the URL. Nothing is mounted on
// this load, so the outcome is only recorded once the hash route loads.
const hashFreeRedirect = hashFreeCallbackRedirect(window.location.pathname, window.location.search);

if (hashFreeRedirect) {
  window.location.replace(hashFreeRedirect);
} else {
  // Survey providers append their tracking params before the '#', where our
  // hash routes cannot see them; this folds them into the hash route while the
  // URL is still untouched — before HashRouter reads it in App.tsx and before
  // any page component mounts.
  normalizeTrackingParams();

  library.add(fas);

  loadVerisoulSDK();

  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
      </Provider>
    </ErrorBoundary>,
    document.getElementById('root'),
  );
}
